import { useMemo } from 'react';

import { useFirebaseValue } from './useFirebaseValue';
import { queryKeys } from '@/lib/queryKeys';
import { STALE_TIMES } from '@/lib/queryClient';
import {
  questionsMapSchema,
  scenariosMapSchema,
  casesMapSchema,
  pokemonMapSchema,
  companiesMapSchema,
  type Question,
  type Scenario,
  type Case,
  type PokemonItem,
} from '@/lib/schemas';

/* =====================================================================
   Hooks de configuración — recursos en /config son inmutables durante
   la sesión del jugador, así que staleTime = LONG.
===================================================================== */

export function useQuestions() {
  const q = useFirebaseValue(queryKeys.config.questions, 'config/questions', questionsMapSchema, {
    staleTime: STALE_TIMES.LONG,
  });
  const list = useMemo<Question[]>(() => (q.data ? Object.values(q.data) : []), [q.data]);
  return { ...q, list };
}

export function useScenarios() {
  const q = useFirebaseValue(queryKeys.config.scenarios, 'config/scenarios', scenariosMapSchema, {
    staleTime: STALE_TIMES.LONG,
  });
  const list = useMemo<Scenario[]>(() => (q.data ? Object.values(q.data) : []), [q.data]);
  return { ...q, list };
}

export function useCases() {
  const q = useFirebaseValue(queryKeys.config.cases, 'config/cases', casesMapSchema, {
    staleTime: STALE_TIMES.LONG,
  });
  const list = useMemo<Case[]>(() => (q.data ? Object.values(q.data) : []), [q.data]);
  return { ...q, list };
}

export function usePokemon() {
  const q = useFirebaseValue(queryKeys.config.pokemon, 'config/pokemon', pokemonMapSchema, {
    staleTime: STALE_TIMES.LONG,
  });
  const list = useMemo<PokemonItem[]>(() => (q.data ? Object.values(q.data) : []), [q.data]);
  return { ...q, list };
}

export function useCompanies() {
  const q = useFirebaseValue(queryKeys.config.companies, 'config/companies', companiesMapSchema, {
    staleTime: STALE_TIMES.LONG,
  });
  const list = useMemo<string[]>(
    () => (q.data ? Object.values(q.data).sort((a, b) => a.localeCompare(b)) : []),
    [q.data],
  );
  return { ...q, list };
}
